export const AccountLoginBadCredentials = "yd:account:login:bad-credentials";
export const AccountLoginUnconfirmed = "yd:account:login:unconfirmed";
